import ClientDiversDetailController from './client.divers.detail.controller';

export default {
    template: require('./client.divers.detail.html'),
    controller: ClientDiversDetailController
};
